import auth from '@/plugins/auth'
import router, { constantRoutes, dynamicRoutes } from '@/router'
import Layout from '@/layout/index'
import ParentView from '@/components/ParentView'
import InnerLink from '@/layout/components/InnerLink'
import { resolveLegacyPage } from '@/config/legacy-page-mapping'


// 1. 单独定义 state、mutations、actions
const state = {
  routes: [],
  addRoutes: [],
  defaultRoutes: [],
  topbarRouters: [],
  sidebarRouters: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_DEFAULT_ROUTES: (state, routes) => {
  state.defaultRoutes = constantRoutes.concat(routes)
},
SET_TOPBAR_ROUTES: (state, routes) => {
  state.topbarRouters = routes
},
SET_SIDEBAR_ROUTERS: (state, routes) => {
  state.sidebarRouters = routes
},
}
// 后端菜单 → 前端标准路由递归转换函数
// const convertAsyncRouter = (list) => {
//
//   return list.map(menu => {
//     let realPath = menu.url || ''
//     // 后端首页url="/" 替换为前端真实首页路由
//     if(realPath === '/'){
//      realPath = '/indexNew/index'
//     }
//     const route = {
//       path: realPath, // 无url默认空字符串""，不会undefined
//       uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//       rawId: menu.id,
//       meta: {
//         title: menu.name,
//         icon: menu.icon || ''
//       },
//       component: 'Layout'
//     }
// if (menu.subMenus && menu.subMenus.length > 0) {
//   // 递归生成子菜单，嵌套进当前routeItem.children
//   route.children = convertAsyncRouter(menu.subMenus);
//   //console.log("子菜单："+route.children)
//   // 父菜单只做折叠容器，不需要页面组件，删除component
//   route.component = undefined;
//   // 无url父菜单path置空字符串，防止path.resolve报错
//   // if (!menu.url) route.path = "";
// } else {
//   // 叶子菜单：绑定页面组件
//   route.component = realPath.replace("/", "");
//   route.children = undefined;
// }
//   return route
// })
// }
// //原来的actions
// const actions = {
//   GenerateRoutes({ commit, rootState }, rawMenu) {
//     return new Promise(resolve => {
//       const convertAsyncRouter = (list) => {
//       return list.map(menu => {
//         let realPath = menu.url || ''
//         // 第一步：替换指定vue路径为html路径（放到最顶部）
//     if (realPath === "/airwayZdmanage/init") {
//       realPath = "ads/airwayZdmanage/airwayZdmanage.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/priceInquiry/init") {
//       realPath = "airfreightrate/priceInquiry/priceInquiry.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/positionManagement/init") {
//       realPath = "airfreightrate/positionManagement/positionManagement.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/plateArrangement/init") {
//       realPath = "airway/plateArrangement/plateArrangement.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/airlinesprice/init") {
//       realPath = "ads/airlinesprice/airlinespriceV1.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/pickupfee/init") {
//       realPath = "ads/pickupfee/pickupfee.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//
//     // 首页单独处理，仅用于侧边栏渲染，不注册动态路由
//     if (realPath === '/') {
//       return {
//         path: '/indexNew/index',
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: { title: menu.name, icon: menu.icon || '' },
//         component: 'Layout',
//         noDynamicRoute: true,
//         hidden: false // 强制显示
//       }
//     }
//
//     if (realPath.endsWith('.html')) {
//       // iframe专用逻辑，直接return，不执行下面replace("/","")
//       return {
//         path: `/iframe/${menu.id}`,
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: {
//           title: menu.name,
//           icon: menu.icon || '',
//           iframeUrl: realPath,
//           isIframePage: true
//         },
//         component: 'iframe/index',
//         hidden: false
//       }
//     }
//
//     // 普通Vue页面路由
//     const route = {
//       path: realPath,
//       uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//       meta: { title: menu.name, icon: menu.icon || '' },
//       component: 'Layout',
//       hidden: false // 全部菜单强制不隐藏
//     }
//
//     if (menu.subMenus && menu.subMenus.length > 0) {
//       route.children = convertAsyncRouter(menu.subMenus);
//       // 父菜单保留component:Layout，不要undefined！！！这是菜单消失最大元凶
//       // route.component = undefined; 删掉这一行！
//       if (!menu.url) route.path = "";
//     } else {
//       route.component = realPath.replace("/", "");
//       //route.children = undefined;
//     }
//     return route
//   })
//   }
//
//     const sidebarRoutes = convertAsyncRouter(rawMenu)
// // 打印转换后的完整菜单，查看目标菜单是否存在
//     console.log('侧边栏完整菜单数据：', JSON.parse(JSON.stringify(sidebarRoutes)))
//
// // 过滤首页，仅用于动态路由注册，侧边栏使用完整未过滤sidebarRoutes
// //     let rewriteRoutes = sidebarRoutes.filter(r => !r.noDynamicRoute)
// //     rewriteRoutes = filterAsyncRouter(rewriteRoutes)
//     let rewriteRoutes = sidebarRoutes.filter(r => !r.noDynamicRoute)
// // 递归转换所有路由组件字符串
//     rewriteRoutes = filterAsyncRouter(rewriteRoutes)
//
// // 单独处理一级iframe页面组件，手动加载
//     rewriteRoutes.forEach(route => {
//       if (route.meta?.isIframePage) {
//       route.component = loadView('iframe/index')
//     }
//   })
//     const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
//     rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
//
//     router.addRoutes([...asyncRoutes, ...rewriteRoutes])
//
//     commit('SET_ROUTES', rewriteRoutes)
//     commit('SET_SIDEBAR_ROUTERS', sidebarRoutes) // 侧边栏用完整原始菜单，未过滤！
//     commit('SET_DEFAULT_ROUTES', sidebarRoutes)
//     commit('SET_TOPBAR_ROUTES', sidebarRoutes)
//     resolve(rewriteRoutes)
//   })
//   }
// }
// const actions = {
//   GenerateRoutes({ commit, rootState }, rawMenu) {
//     return new Promise(resolve => {
//       // 递归时传递父层级信息，给iframe路由标记层级深度
//       const convertAsyncRouter = (list, parentDepth = 1) => {
//       return list.map(menu => {
//         let realPath = menu.url || ''
//         // 路径映射替换逻辑完全保留
//         if (realPath === "/airwayZdmanage/init") {
//       realPath = "ads/airwayZdmanage/airwayZdmanage.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/priceInquiry/init") {
//       realPath = "airfreightrate/priceInquiry/priceInquiry.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/positionManagement/init") {
//       realPath = "airfreightrate/positionManagement/positionManagement.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/plateArrangement/init") {
//       realPath = "airway/plateArrangement/plateArrangement.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/airlinesprice/init") {
//       realPath = "ads/airlinesprice/airlinespriceV1.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/pickupfee/init") {
//       realPath = "ads/pickupfee/pickupfee.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//
//     // 首页单独处理
//     if (realPath === '/') {
//       return {
//         path: '/indexNew/index',
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: { title: menu.name, icon: menu.icon || '', menuDepth: parentDepth },
//         component: 'Layout',
//         noDynamicRoute: true,
//         hidden: false
//       }
//     }
//
//     // iframe路由：新增标记当前菜单层级深度
//     if (realPath.endsWith('.html')) {
//       return {
//         path: `/iframe/${menu.id}`,
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: {
//           title: menu.name,
//           icon: menu.icon || '',
//           iframeUrl: realPath,
//           isIframePage: true,
//           menuDepth: parentDepth // 记录当前菜单层级
//         },
//         component: 'iframe/index',
//         hidden: false
//       }
//     }
//
//     // 普通Vue路由
//     const route = {
//       path: realPath,
//       uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//       meta: { title: menu.name, icon: menu.icon || '', menuDepth: parentDepth },
//       component: 'Layout',
//       hidden: false
//     }
//
//     if (menu.subMenus && menu.subMenus.length > 0) {
//       // 子菜单层级+1
//       route.children = convertAsyncRouter(menu.subMenus, parentDepth + 1);
//       if (!menu.url) route.path = "";
//     } else {
//       route.component = realPath.replace("/", "");
//     }
//     return route
//   })
//   }
//
//     // 初始调用层级从1开始
//     const sidebarRoutes = convertAsyncRouter(rawMenu, 1)
//     console.log('侧边栏完整菜单数据：', JSON.parse(JSON.stringify(sidebarRoutes)))
//
//     let rewriteRoutes = sidebarRoutes.filter(r => !r.noDynamicRoute)
//     rewriteRoutes = filterAsyncRouter(rewriteRoutes)
//
//     rewriteRoutes.forEach(route => {
//       if (route.meta?.isIframePage) {
//       route.component = loadView('iframe/index')
//     }
//   })
//     const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
//     rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
//
//     router.addRoutes([...asyncRoutes, ...rewriteRoutes])
//     commit('SET_ROUTES', rewriteRoutes)
//     commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
//     commit('SET_DEFAULT_ROUTES', sidebarRoutes)
//     commit('SET_TOPBAR_ROUTES', sidebarRoutes)
//     resolve(rewriteRoutes)
//   })
//   }
// }
// 遍历后台传来的路由字符串，转换为组件对象
// const actions = {
//   GenerateRoutes({ commit, rootState }, rawMenu) {
//     return new Promise(resolve => {
//       // 递归增加层级参数，标记三级iframe
//       const convertAsyncRouter = (list, depth = 1) => {
//       return list.map(menu => {
//         let realPath = menu.url || ''
//         // 路径映射逻辑完全不动
//         if (realPath === "/airwayZdmanage/init") {
//       realPath = "ads/airwayZdmanage/airwayZdmanage.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/priceInquiry/init") {
//       realPath = "airfreightrate/priceInquiry/priceInquiry.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/positionManagement/init") {
//       realPath = "airfreightrate/positionManagement/positionManagement.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/plateArrangement/init") {
//       realPath = "airway/plateArrangement/plateArrangement.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/airlinesprice/init") {
//       realPath = "ads/airlinesprice/airlinespriceV1.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//     if (realPath === "/pickupfee/init") {
//       realPath = "ads/pickupfee/pickupfee.html"
//       console.log('匹配到目标菜单，转换iframe路径：', realPath, menu.name)
//     }
//
//     // 首页
//     if (realPath === '/') {
//       return {
//         path: '/indexNew/index',
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: { title: menu.name, icon: menu.icon || '' },
//         component: 'Layout',
//         noDynamicRoute: true,
//         hidden: false
//       }
//     }
//
//     // iframe页面，标记是否三级菜单
//     if (realPath.endsWith('.html')) {
//       return {
//         path: `/iframe/${menu.id}`,
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: {
//           title: menu.name,
//           icon: menu.icon || '',
//           iframeUrl: realPath,
//           isIframePage: true,
//           isThirdLevelIframe: depth === 3 // 关键标记：三级iframe
//         },
//         component: 'iframe/index',
//         hidden: false
//       }
//     }
//
//     // 普通路由
//     const route = {
//       path: realPath,
//       uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//       meta: { title: menu.name, icon: menu.icon || '' },
//       component: 'Layout',
//       hidden: false
//     }
//
//     if (menu.subMenus && menu.subMenus.length > 0) {
//       // 子菜单层级+1
//       route.children = convertAsyncRouter(menu.subMenus, depth + 1);
//       if (!menu.url) route.path = "";
//     } else {
//       route.component = realPath.replace("/", "");
//     }
//     return route
//   })
//   }
//
//     const sidebarRoutes = convertAsyncRouter(rawMenu, 1)
//     console.log('侧边栏完整菜单数据：', JSON.parse(JSON.stringify(sidebarRoutes)))
//
//     let rewriteRoutes = sidebarRoutes.filter(r => !r.noDynamicRoute)
//     rewriteRoutes = filterAsyncRouter(rewriteRoutes)
//
//     rewriteRoutes.forEach(route => {
//       if (route.meta?.isIframePage) {
//       route.component = loadView('iframe/index')
//     }
//   })
//     const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
//     rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
//
//     router.addRoutes([...asyncRoutes, ...rewriteRoutes])
//     commit('SET_ROUTES', rewriteRoutes)
//     commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
//     commit('SET_DEFAULT_ROUTES', sidebarRoutes)
//     commit('SET_TOPBAR_ROUTES', sidebarRoutes)
//     resolve(rewriteRoutes)
//   })
//   }
// }
//

//
// const actions = {
//   GenerateRoutes({ commit, rootState }, rawMenu) {
//     return new Promise(resolve => {
//       // 存放需要提升到顶层的三级iframe路由
//       const topIframeRoutes = []
//       // 第一步：生成完整树形菜单（给侧边栏渲染，保留全部三级子菜单，二级目录不会消失）
//       const fullSidebarTree = convertFullTree(rawMenu, 1)
//       // 第二步：复制树形，移除二级目录下的三级iframe（用于路由注册，切断嵌套Layout）
//       const routeRegisterTree = JSON.parse(JSON.stringify(fullSidebarTree))
//       removeThirdIframeFromChildren(routeRegisterTree)
//
//       // 合并顶层iframe，生成路由注册列表
//       let rewriteRoutes = [...routeRegisterTree, ...topIframeRoutes]
//     rewriteRoutes = rewriteRoutes.filter(r => !r.noDynamicRoute)
//     rewriteRoutes = filterAsyncRouter(rewriteRoutes)
//
//     rewriteRoutes.forEach(route => {
//       if (route.meta?.isIframePage) {
//       route.component = loadView('iframe/index')
//     }
//   })
//     const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
//     rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
//     router.addRoutes([...asyncRoutes, ...rewriteRoutes])
//
//     // 侧边栏使用完整树形，路由使用剥离iframe后的树形
//     commit('SET_ROUTES', rewriteRoutes)
//     commit('SET_SIDEBAR_ROUTERS', fullSidebarTree)
//     commit('SET_DEFAULT_ROUTES', fullSidebarTree)
//     commit('SET_TOPBAR_ROUTES', fullSidebarTree)
//     resolve(rewriteRoutes)
//
//     // 内部方法1：生成完整侧边栏树形（不删除任何子菜单）
//     function convertFullTree(list, depth = 1) {
//       return list.map(menu => {
//         let realPath = menu.url || ''
//         // 路径映射规则不变
//         if (realPath === "/airwayZdmanage/init") realPath = "ads/airwayZdmanage/airwayZdmanage.html"
//       if (realPath === "/priceInquiry/init") realPath = "airfreightrate/priceInquiry/priceInquiry.html"
//       if (realPath === "/positionManagement/init") realPath = "airfreightrate/positionManagement/positionManagement.html"
//       if (realPath === "/plateArrangement/init") realPath = "airway/plateArrangement/plateArrangement.html"
//       if (realPath === "/airlinesprice/init") realPath = "ads/airlinesprice/airlinespriceV1.html"
//       if (realPath === "/pickupfee/init") realPath = "ads/pickupfee/pickupfee.html"
//
//       if (realPath === '/') {
//         return {
//           path: '/indexNew/index',
//           uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//           meta: { title: menu.name, icon: menu.icon || '' },
//           component: 'Layout',
//           noDynamicRoute: true,
//           hidden: false
//         }
//       }
//
//       // iframe路由
//       if (realPath.endsWith('.html')) {
//         const iframeRoute = {
//           path: `/iframe/${menu.id}`,
//           uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//           meta: {
//             title: menu.name,
//             icon: menu.icon || '',
//             iframeUrl: realPath,
//             isIframePage: true,
//             menuDepth: depth
//           },
//           component: 'iframe/index',
//           hidden: false
//         }
//         // 三级iframe单独存入顶层数组
//         if (depth === 3) topIframeRoutes.push(iframeRoute)
//         return iframeRoute
//       }
//
//       const route = {
//         path: realPath,
//         uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
//         meta: { title: menu.name, icon: menu.icon || '' },
//         component: 'Layout',
//         hidden: false
//       }
//       if (menu.subMenus && menu.subMenus.length > 0) {
//         route.children = convertFullTree(menu.subMenus, depth + 1)
//         if (!menu.url) route.path = ""
//       } else {
//         route.component = realPath.replace("/", "");
//       }
//       return route
//     })
//     }
//
//     // 内部方法2：递归移除树形里二级目录下的三级iframe
//     function removeThirdIframeFromChildren(treeList) {
//       treeList.forEach(item => {
//         if (item.children && item.children.length) {
//         // 过滤掉三级iframe，路由注册时不再嵌套
//         item.children = item.children.filter(child => !(child.meta?.isIframePage && child.meta.menuDepth === 3))
//         removeThirdIframeFromChildren(item.children)
//       }
//     })
//     }
//   })
//   }
// }
//
const actions = {
  GenerateRoutes({ commit, rootState }, rawMenu) {
    return new Promise(resolve => {
      // 存储顶层Layout包裹的三级iframe路由
      const topIframeRoutes = []

      // 1. 生成侧边栏完整树形（保留全部三级子菜单，侧边栏层级完整）
      const convertFullSidebarTree = (list, depth = 1) => {
      return list.map(menu => {
        let realPath = menu.url || ''

        // 分离查询参数：/hkFollow/init?type=ALL → path: /hkFollow/init, extraQuery: ?type=ALL
        // 这些参数来自数据库菜单 URL，需要在 iframe 加载时传递给目标页面
        let extraQuery = ''
        const qIndex = realPath.indexOf('?')
        if (qIndex !== -1) {
          extraQuery = realPath.substring(qIndex)
          realPath = realPath.substring(0, qIndex)
        }

        // 统一通过配置解析旧页面路径（替代原来的 6 个 if 硬编码）
        const legacyResult = resolveLegacyPage(realPath)
        if (legacyResult.isLegacy) {
          realPath = legacyResult.iframeUrl
        }

        // 首页特殊路由
    if (realPath === '/') {
      return {
        path: '/indexNew',
        uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
        meta: { title: menu.name, icon: menu.icon || '' },
        component: 'Layout',
        noDynamicRoute: true,
        hidden: false
      }
    }

    // iframe页面
    if (realPath.endsWith('.html')) {
      // 原始菜单 URL 中的查询参数（如 ?type=ALL）追加到 iframeUrl，传递给目标页面
      // 对于 hkFollow 页面，将当前用户账号作为 follow_person 默认值
      // 解决 session 在 iframe 中不可用时 curUser 为 null 的问题
      let fullExtraQuery = extraQuery
      const userAccount = rootState.user.name
      if (userAccount && realPath.includes('hkFollow')) {
        const sep = extraQuery ? '&' : '?'
        if (!extraQuery.includes('follow_person=')) {
          fullExtraQuery = extraQuery + sep + 'follow_person=' + encodeURIComponent(userAccount)
        }
      }
      const fullIframeUrl = realPath + fullExtraQuery
      // 构建完整 iframe 链接，供 IframeToggle 使用（v-show 切换，保持 iframe 内容不丢失）
      // dev 用跨域直接指向 Spring Boot（iframe 内 JS 重定向用绝对路径如 /hkFollow/init，需解析到 Spring Boot 而非 Vue devServer）
      // 生产用同域相对路径（Nginx 统一代理到 Spring Boot）
      const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8081' : ''
      const iframeItem = {
        path: `/iframe/${menu.id}`,
        name: 'IframePage',
        uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
        meta: {
          title: menu.name,
          icon: menu.icon || '',
          link: `${baseUrl}/modules/${fullIframeUrl}`,     // IframeToggle 使用，v-show 保持 iframe 内容
          iframeUrl: fullIframeUrl,                         // 保留兼容旧逻辑
          isIframePage: true,
          menuDepth: depth
        },
        component: 'iframe/index',
        hidden: false
      }
      // 三级iframe：生成【外层Layout + 子iframe】路由，存入顶层数组
      if (depth === 3) {
        topIframeRoutes.push({
          path: iframeItem.path,
          uniqueKey: iframeItem.uniqueKey,
          meta: { ...iframeItem.meta, breadcrumb: false }, // 父Layout不参与面包屑，避免与子路由path相同导致重复key
          component: 'Layout', // 外层包裹Layout，保证顶部导航、侧边栏显示
          hidden: false,
          children: [iframeItem]
        })
      }
      return iframeItem
    }

    // 普通目录路由
    const route = {
      path: realPath,
      uniqueKey: menu.id ? `menu_${menu.id}` : `rand_${Math.random().toString(36)}`,
      meta: { title: menu.name, icon: menu.icon || '' },
      component: 'Layout',
      hidden: false
    }

    if (menu.subMenus && menu.subMenus.length > 0) {
      route.children = convertFullSidebarTree(menu.subMenus, depth + 1)
      if (!menu.url) {
        route.path = ""
        route.alwaysShow = true // 空url父菜单始终显示，避免单子菜单折叠导致父级不展示
      }
    } else {
      route.component = realPath.replace("/", "");
    }
    return route
  })
  }

    // 侧边栏完整树形菜单（一级→二级→三级全部存在，UI正常展示）
    const fullSidebarTree = convertFullSidebarTree(rawMenu, 1)

    // 复制树形，移除二级目录下的三级iframe（路由注册不再嵌套，解决双层Layout）
    const routeTree = JSON.parse(JSON.stringify(fullSidebarTree))
    const removeThirdIframeChildren = (treeList) => {
      treeList.forEach(item => {
        if (item.children && item.children.length) {
        item.children = item.children.filter(child => !(child.meta?.isIframePage && child.meta.menuDepth === 3))
        removeThirdIframeChildren(item.children)
      }
    })
    }
    removeThirdIframeChildren(routeTree)

    // 组装最终动态路由：过滤首页 + 剥离后的树形 + 带Layout的顶层iframe
    let rewriteRoutes = [...routeTree, ...topIframeRoutes]
    rewriteRoutes = rewriteRoutes.filter(r => !r.noDynamicRoute)
    rewriteRoutes = filterAsyncRouter(rewriteRoutes)

    // 统一处理iframe组件加载
    rewriteRoutes.forEach(route => {
      if (route.children && route.children.length) {
      route.children.forEach(child => {
        if (child.meta?.isIframePage) {
        child.component = loadView('iframe/index')
      }
    })
    }
  })

    // 恢复 postMessage 动态添加的 iframe-legacy 路由（刷新后丢失，从 sessionStorage 恢复）
    try {
      const stored = JSON.parse(sessionStorage.getItem('_legacy_routes') || '[]')
      if (stored.length > 0) {
        const legacyRoutes = stored.map(item => ({
          path: `/iframe-legacy/${item.timestamp}`,
          component: () => import('@/layout'),
          redirect: 'noRedirect',
          hidden: true,
          children: [{
            path: 'index',
            name: `IframePage_${item.timestamp}`,
            component: () => import('@/views/iframe/index'),
            meta: {
              title: item.title,
              isIframePage: true,
              link: item.link,
              iframeUrl: item.normalizedIframeUrl,
              uniqueKey: item.uniqueKey || item.title
            }
          }]
        }))
        rewriteRoutes.push(...legacyRoutes)
      }
    } catch(e) {
      console.error('恢复 iframe-legacy 路由失败：', e)
    }

    const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
    rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
    router.addRoutes([...asyncRoutes, ...rewriteRoutes])

    // Vuex存储完整侧边栏树形，菜单层级不丢失
    commit('SET_ROUTES', rewriteRoutes)
    commit('SET_SIDEBAR_ROUTERS', fullSidebarTree)
    commit('SET_DEFAULT_ROUTES', fullSidebarTree)
    commit('SET_TOPBAR_ROUTES', fullSidebarTree)
    resolve(rewriteRoutes)
  })
  }
}
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
    route.children = filterChildren(route.children)
  }
  if (route.component) {
    // Layout ParentView 组件特殊处理
    if (route.component === 'Layout') {
      route.component = Layout
    } else if (route.component === 'ParentView') {
      route.component = ParentView
    } else if (route.component === 'InnerLink') {
      route.component = InnerLink
    } else {
      route.component = loadView(route.component)
    }
  }
  if (route.children != null && route.children && route.children.length) {
    route.children = filterAsyncRouter(route.children, route, type)
  } else {
    delete route['children']
    delete route['redirect']
  }
  return true
})
}
// 加载页面组件
// export const loadView = (view) => {
//   return () => import(`@/views/${view}`)
// }
// 递归处理异步路由组件
// export const filterAsyncRouter = (routes) => {
//   return routes.filter(route => {
//     if (route.component) {
//     if (typeof route.component === 'string') {
//       route.component = loadView(route.component)
//     }
//   }
//   if (route.children && route.children.length) {
//     route.children = filterAsyncRouter(route.children)
//   }
//   return true
// })
// }
// 固定基础路由
// const dynamicRoutes = []
function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach(el => {
    el.path = lastRouter ? lastRouter.path + '/' + el.path : el.path
    if (el.children && el.children.length && el.component === 'ParentView') {
    children = children.concat(filterChildren(el.children, el))
  } else {
    children.push(el)
  }
})
  return children
}
// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
    if (auth.hasPermiOr(route.permissions)) {
      res.push(route)
    }
  } else if (route.roles) {
    if (auth.hasRoleOr(route.roles)) {
      res.push(route)
    }
  }
})
  return res
}
export const loadView = (view) => {
  if (process.env.NODE_ENV === 'development') {
    return (resolve) => require([`@/views/${view}`], resolve)
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views/${view}`)
  }
}

// 导出模块，直接使用上面定义好的变量
export default {
  namespaced: false,
  state,
  mutations,
  actions
}
